module.exports = __webpack_public_path__ + "static/media/medtronic.f301358c.jpg";